import React from "react";
import "./imgs.scss";

export const WMLogoSmall = () => {
  return (
    <figure className="wm-logo-small-figure">
      <a href="https://withme.com/" target="_blank">
        <img
          src="https://s3.us-east-1.amazonaws.com/printwithme.com/withme/wm_logo_small_300x202.webp"
          data-testid="wm-logo-small"
        />
      </a>
    </figure>
  );
};
